import api from "utils/api";

// Get company details
export const getCompany = async () => {
  try {
    const response = await api.get("/company");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update company details with file upload support
export const updateCompany = async (companyData) => {
  try {
    // Check if companyData is FormData (for file uploads)
    const isFormData = companyData instanceof FormData;

    const response = await api.put("/company", companyData, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
